import { ReactNode } from 'react'

import { StyledList, StyledListItem} from '../TextStyle'
import { LinkText } from '@/components/elements/LinkText'

export const codeItems: { children: ReactNode; id: string }[] = [
  {
    children: (
      <>
        <h3>1. Respect for Human Rights</h3>
        <StyledList marginLeft="0.5" paddingLeft="0.5">
          <StyledListItem listType="boldArticle">
            TRIAL Group&apos;s Basic Policies
            <StyledList marginLeft="1.5" paddingLeft="0.5">
              <StyledListItem listType="number">
                TRIAL Group (representing TRIAL Holdings, Inc. and its group companies*) shall understand various international norms regarding human rights and respect fundamental human rights in accordance with the laws and regulations of each country and region. We shall not tolerate child labor or forced labor.
                <p>
                 * 
                  <LinkText path="/en/company/overview/" text="Here " />
                  are the group companies of TRIAL Holdings, Inc.
                </p>
              </StyledListItem>
              <StyledListItem listType="number">
                If any act that infringes on fundamental human rights is found in the TRIAL Group, appropriate measures shall be taken. In addition, if any act that infringes on fundamental human rights by our business partners is recognized, we shall seek improvement and take appropriate measures.
                <br />
                We shall promote dialogue with relevant stakeholders to ensure respect for human rights.
              </StyledListItem>
            </StyledList>
          </StyledListItem>
          <StyledListItem listType="boldArticle">
            TRIAL Group&apos;s Code of Conduct for Directors and Employees
            <StyledList marginLeft="1.5" paddingLeft="0.5">
              <StyledListItem listType="number">
                We shall respect the fundamental human rights, individuality, and privacy of individuals and are receptive to diverse values.
              </StyledListItem>
              <StyledListItem listType="number">
                We shall not engage in any acts which infringe on human rights, such as discriminatory language or actions, acts of violence, sexual harassment, or power harassment, etc. related to race, religion, gender, nationality, mental or physical disability, age, sexual orientation, etc.
              </StyledListItem>
            </StyledList>
          </StyledListItem>
        </StyledList>
      </>
    ),
    id: 'policy1',
  },
  {
    children: (
      <>
        <h3>2. Respect for Customers</h3>
        <StyledList marginLeft="0.5" paddingLeft="0.5">
          <StyledListItem listType="boldArticle">
            TRIAL Group&apos;s Basic Policies
            <StyledList marginLeft="1.5" paddingLeft="0.5">
              <StyledListItem listType="number">
                We shall comply with laws and regulations, observe contractual matters, and provide products, goods, systems, and services (hereinafter referred to as &quot;Products&quot;) that satisfy our customers.
              </StyledListItem>
            </StyledList>
          </StyledListItem>
          <StyledListItem listType="boldArticle">
            TRIAL Group&apos;s Code of Conduct for Directors and Employees
            <StyledList marginLeft="1.5" paddingLeft="0.5">
              <StyledListItem listType="number">
                We shall provide safe and reliable Products.
              </StyledListItem>
              <StyledListItem listType="number">
                We shall provide appropriate information regarding Products.
              </StyledListItem>
              <StyledListItem listType="number">
                We shall respond to customer requests and consultations sincerely, promptly, and accurately.
              </StyledListItem>
              <StyledListItem listType="number">
                We shall value customer feedback and strive to work on the lineup, pricing, development, and improvement of Products to satisfy our customers.
              </StyledListItem>
            </StyledList>
          </StyledListItem>
        </StyledList>
      </>
    ),
    id: 'policy2',
  },
  {
    children: (
      <>
        <h3>3. Sales, Productions, Technical Activities and Quality Activities</h3>
        <StyledList marginLeft="0.5" paddingLeft="0.5">
          <StyledListItem listType="boldArticle">
            TRIAL Group&apos;s Basic Policies
            <StyledList marginLeft="1.5" paddingLeft="0.5">
              <StyledListItem listType="number">
                We shall comply with all laws, regulations, and contracts related to sales, production, technical activities, and quality activities.
              </StyledListItem>
              <StyledListItem listType="number">
                We shall provide safe, secure, and superior Products with the latest and best technologies for the needs of our customers, with price settings to make our customers satisfied and our tireless efforts for technological innovation, and productivity improvements.
              </StyledListItem>
            </StyledList>
          </StyledListItem>
          <StyledListItem listType="boldArticle">
            TRIAL Group&apos;s Code of Conduct for Directors and Employees
            <StyledList marginLeft="1.5" paddingLeft="0.5">
              <StyledListItem listType="number">
                We shall fulfill our responsibility for quality assurance and ensure the safety of Products from the standpoint of our customers.
              </StyledListItem>
              <StyledListItem listType="number">
                We shall promote advanced research and development, improve our technological capabilities, and develop our technological base. In addition, we shall strive to inherit accumulated technologies and skills, accurately respond to change in the technological environment, and utilize the latest technologies in our Products.
              </StyledListItem>
              <StyledListItem listType="number">
                When we receive information concerning accidents or safety related to Products, we shall immediately confirm the facts, provide necessary information to customers in accordance with internal rules, and take appropriate measures such as product recalls, alerts, and warning labels.
              </StyledListItem>
            </StyledList>
          </StyledListItem>
        </StyledList>
      </>
    ),
    id: 'policy3',
  },
  {
    children: (
      <>
        <h3>4. Business Activities</h3>
        <StyledList marginLeft="0.5" paddingLeft="0.5">
          <StyledListItem listType="boldArticle">
            TRIAL Group&apos;s Basic Policies
            <StyledList marginLeft="1.5" paddingLeft="0.5">
              <StyledListItem listType="number">
                We shall conduct fair business activities in compliance with laws and regulations and based on sound corporate ethics.
              </StyledListItem>
              <StyledListItem listType="number">
                We shall provide superior Products that satisfy customers&apos; needs.
              </StyledListItem>
            </StyledList>
          </StyledListItem>
          <StyledListItem listType="boldArticle">
            TRIAL Group&apos;s Code of Conduct for Directors and Employees
            <StyledList marginLeft="1.5" paddingLeft="0.5">
              <StyledListItem listType="number">
                We shall treat all customers fairly and impartially in good faith and conduct transactions on appropriate terms.
              </StyledListItem>
              <StyledListItem listType="number">
                We shall comply with laws and regulations and conduct business activities in accordance with sound business practices and socially accepted ideas.
              </StyledListItem>
              <StyledListItem listType="number">
                We shall strive to accurately understand the needs of our customers and provide them with the most appropriate Products.
              </StyledListItem>
            </StyledList>
          </StyledListItem>
        </StyledList>
      </>
    ),
    id: 'policy4',
  },
  {
    children: (
      <>
        <h3>5. Compliance with Antimonopoly Laws, Government Transaction Regulations, etc.</h3>
        <StyledList marginLeft="0.5" paddingLeft="0.5">
          <StyledListItem listType="boldArticle">
            TRIAL Group&apos;s Basic Policies
            <StyledList marginLeft="1.5" paddingLeft="0.5">
              <StyledListItem listType="number">
                We shall comply with the Antimonopoly Law and other laws and regulations to maintain fair competition (hereinafter referred to as &quot;Antimonopoly Laws&quot;).
              </StyledListItem>
              <StyledListItem listType="number">
                We shall comply with laws and regulations and sound business practices in our dealings with government agencies.
              </StyledListItem>
            </StyledList>
          </StyledListItem>
          <StyledListItem listType="boldArticle">
            TRIAL Group&apos;s Code of Conduct for Directors and Employees
            <StyledList marginLeft="1.5" paddingLeft="0.5">
              <StyledListItem listType="number">
                We shall comply with internal rules and regulations pertaining to legal compliance and promote fair and free business activities.
              </StyledListItem>
              <StyledListItem listType="number">
                If our customer is the government agency, we shall comply with internal rules and regulations, etc. pertaining to government agency business and shall not provide any false information such as fraudulent estimates to the government agency or its employees (including former employees; the same shall apply hereinafter).
              </StyledListItem>
              <StyledListItem listType="number">
                We shall not engage in any activities that could be suspected of being illegal, such as forming or participating in meetings, making commitments and arrangements, or exchanging information.
              </StyledListItem>
            </StyledList>
          </StyledListItem>
        </StyledList>
      </>
    ),
    id: 'policy5',
  },
  {
    children: (
      <>
        <h3>6. Prohibition of Bribery</h3>
        <StyledList marginLeft="0.5" paddingLeft="0.5">
          <StyledListItem listType="boldArticle">
            TRIAL Group&apos;s Basic Policies
            <StyledList marginLeft="1.5" paddingLeft="0.5">
              <StyledListItem listType="number">
                We shall not make improper expenditures in violation of laws and regulations or sound business practices.
              </StyledListItem>
              <StyledListItem listType="number">
                We shall not provide inappropriate benefits or favors to politicians or political groups.
              </StyledListItem>
            </StyledList>
          </StyledListItem>
          <StyledListItem listType="boldArticle">
            TRIAL Group&apos;s Code of Conduct for Directors and Employees
            <StyledList marginLeft="1.5" paddingLeft="0.5">
              <StyledListItem listType="number">
                We shall not provide benefits, directly or indirectly, to government employees, deemed public officials, politicians, etc. (including former members of Congress, secretaries, former secretaries, candidates for Congress, etc., hereinafter referred to as &quot;Public Officials and Politicians&quot;), or political organizations, etc., in any form including compensation, entertainment, or gifts in violation of laws and regulations or sound business practices (Except in cases where such benefits do not violate laws and regulations and are socially appropriate). In addition, we shall not engage in sales or loans, etc. on terms that are more favorable than normal business practices.
              </StyledListItem>
              <StyledListItem listType="number">
                We shall not pay any money or provide any benefits to Public Officials and Politicians, or companies related to them, in connection with sales to government agencies, regardless of whether such benefits are in the form of commission or consulting fees, etc.
              </StyledListItem>
              <StyledListItem listType="number">
                We shall not provide money or other benefits to foreign public officials, etc., to obtain improper business benefits in connection with international business transactions.
              </StyledListItem>
              <StyledListItem listType="number">
                We shall not allow third parties, such as agents, to engage in any of the prohibited acts set forth in (a)~(c) above.
              </StyledListItem>
              <StyledListItem listType="number">
                If we use agents, etc., we shall reasonably agree on their remuneration, etc. in advance. If there are legal restrictions on the payment of remuneration, we shall comply with such laws and regulations.
              </StyledListItem>
              <StyledListItem listType="number">
                We shall not make inappropriate political contributions to politicians, etc. or political groups in violation of laws and regulations or internal rules.
              </StyledListItem>
              <StyledListItem listType="number">
                We shall comply with laws and regulations when we provide business entertainment, gifts, expenditures, etc.
              </StyledListItem>
            </StyledList>
          </StyledListItem>
        </StyledList>
      </>
    ),
    id: 'policy6',
  },
  {
    children: (
      <>
        <h3>7. Exclusion of Antisocial Forces</h3>
        <StyledList marginLeft="0.5" paddingLeft="0.5">
          <StyledListItem listType="boldArticle">
            TRIAL Group&quot;s Basic Policies
            <StyledList marginLeft="1.5" paddingLeft="0.5">
              <StyledListItem listType="number">
                We shall not have any relationship including business transactions with Antisocial Forces (Note 1)
              </StyledListItem>
            </StyledList>
          </StyledListItem>
          <StyledListItem listType="boldArticle">
            TRIAL Group&quot;s Code of Conduct for Directors and Employees
            <StyledList marginLeft="1.5" paddingLeft="0.5">
              <StyledListItem listType="number">
                We shall reject any involvement in business activities by Antisocial Forces. In addition, we shall not promote the activities (Note 2).
              </StyledListItem>
              <StyledListItem listType="number">
                If we receive an unreasonable request (Note 3), we shall firmly reject the request.
              </StyledListItem>
              <StyledListItem listType="number">
                We shall comply with laws and regulations governing money laundering (transfer of proceeds from crime).
              </StyledListItem>
            </StyledList>
          </StyledListItem>
        </StyledList>
        <StyledList marginLeft="5" paddingLeft="0.5">
          <StyledListItem listType="comment">
            Antisocial Forces: groups or individuals who pursue economic benefits using violence, force, and fraudulent methods.
          </StyledListItem>
          <StyledListItem listType="comment">
            Acts that promote Antisocial Forces activities: subscriptions to magazines and books, purchases of goods, support for advertisements, transactions such as the provision of services, provision of money and goods, and other favors.
          </StyledListItem>
          <StyledListItem listType="comment">
            Unreasonable Request: violent acts, etc. of request committed by gangsters with business activities.
          </StyledListItem>
        </StyledList>
      </>
    ),
    id: 'policy7',
  },
  {
    children: (
      <>
        <p>
          Date of Enactment :
          December 26, 2022
        </p>
      </>
    ),
    id: 'policy8',
  },
]

export const codeLinks: {
  name: string
  anchor: string
}[][] = [
  [
    {
      name: '（Respect for Human Rights）',
      anchor: 'policy1',
    },
    {
      name: '（Respect for Customers）',
      anchor: 'policy2',
    },
    {
      name: '（Sales, Productions, Technical Activities and Quality Activities）',
      anchor: 'policy3',
    },
    {
      name: '（Business Activities）',
      anchor: 'policy4',
    },
  ],
  [
    {
      name: '（Compliance with Antimonopoly Laws, Government Transaction Regulations, etc.）',
      anchor: 'policy5',
    },
    {
      name: '（Prohibition of Bribery）',
      anchor: 'policy6',
    },
    {
      name: '（Exclusion of Antisocial Forces）',
      anchor: 'policy7',
    },
  ],
]
